import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MaterialTable from 'material-table';

// Helpers
import {
  getActions,
  getColumns,
  mapTableData,
  getLocalization,
  defaultTableOptions,
} from 'util/table-utils';
import { CONTRACTS_TABLE_COLUMNS } from 'constants/ui-constants';
import { PATHS } from 'util/appConstants';

// Actions
import { useContracts } from 'hooks';
import { deleteContract, selectContractStatus, searchFilter, setSearch } from 'redux/slices/contractsSlice';
import { selectUser } from 'redux/slices/userSlice';

// Components
import withConfirm from 'components/dialogs/delete';


const tableTitle = 'CONTRACTS';

const ContractsList = ({ confirm }) => {
  const { t } = useTranslation('common');
  const user = useSelector(selectUser);
  const loading = useSelector(selectContractStatus);
  const history = useHistory();
  const dispatch = useDispatch();
  const { contracts, revalidate } = useContracts();
  const search = useSelector(searchFilter);

  const callbackOnDelete = (e, { id }) => {
    e.stopPropagation();

    confirm(
      () => {
        dispatch(deleteContract(id));
        revalidate();
      },
      { description: 'Are you sure?' },
    );
  };

  const actions = useMemo(
    () => getActions(
      user,
      tableTitle,
      () => history.push(PATHS.contracts.add),
      (e, rowData) => callbackOnDelete(e, rowData),
    ), [user]);

  if (!user || loading) {
    return (
      <div>Loading..</div>
    );
  }

  return (
    <div className={'custom-table-styles'}>
      <MaterialTable
        data={mapTableData(contracts)}
        title={t(tableTitle)}
        actions={actions}
        columns={getColumns(CONTRACTS_TABLE_COLUMNS, t)}
        options={{
          ...defaultTableOptions,
          searchText: search
        }}
        minRows={0}
        localization={getLocalization(t)}
        onRowClick={(e, { _id }) => {
          history.push(
            PATHS.contracts.edit.replace(':id', _id),
          );
        }}
        onSearchChange={(searchStr) => dispatch(setSearch(searchStr))}
      />
    </div>
  );
};

export default withConfirm(ContractsList);
